import { Tooltip } from 'bootstrap'
import { i18n } from '@/i18n'

export default {
  mounted (el, binding) {
    applyTooltip(el, binding)
  },
  updated (el, binding) {
    applyTooltip(el, binding)
  },
  unmounted (el) {
    const instance = Tooltip.getInstance(el)
    if (instance) instance.dispose()
  }
}

function applyTooltip (el, binding) {
  const value = binding.value
  let text = ''

  // -----------------------------------------
  // 1) i18n mit Parametern: { key, params }
  // 2) i18n-Key als String
  // 3) Funktion → dynamischer Tooltip
  // 4) Fallback: direkter Text
  // -----------------------------------------
  if (typeof value === 'object' && value.key) {
    text = i18n.global.t(value.key, value.params || {})
  } else if (typeof value === 'string') {
    text = i18n.global.t(value)
  } else if (typeof value === 'function') {
    text = value()
  } else {
    text = String(value)
  }

  // -----------------------------------------
  // WICHTIG: Quill-HTML in Wrapper packen,
  // damit deine .my-rendered-content CSS greift
  // -----------------------------------------
  const wrapped = `<div class="my-rendered-content">${text}</div>`

  // -----------------------------------------
  // Placement über Modifiers
  // -----------------------------------------
  let placement = 'bottom'
  const mods = binding.modifiers

  if (mods.top) placement = 'top'
  if (mods.left) placement = 'left'
  if (mods.right) placement = 'right'
  if (mods.bottom) placement = 'bottom'

  // -----------------------------------------
  // Tooltip erzeugen oder aktualisieren
  // -----------------------------------------
  let instance = Tooltip.getInstance(el)

  if (!instance) {
    instance = new Tooltip(el, {
      title: wrapped,
      html: true,
      sanitize: false, // Quill-HTML behalten!
      placement
    })
  } else {
    instance.setContent({ '.tooltip-inner': wrapped })
  }
}
